/* src/app/core/widgets/audit-line/audit-line.component.scss */
.auditLineContainer {
  font-weight: bold;
  font-size: 0.8rem;
  color: gray;
}
/*# sourceMappingURL=audit-line.component.css.map */
